// @flow

import React, {Component} from 'react'
import css from './MedicineGuideItem.css'

type State = {
  show: boolean,
  style: Object,
}

type Props = {
  text: string
}

class MedicineGuideItemText extends Component {
  props: Props

  state: State = {
    show: true,
    style : {maxHeight: 0},
  }

  componentWillReceiveProps(newProps: Object) {
    if(!newProps.mounted)
      return this.unMountStyle()
    this.setState({show: true})
    setTimeout(this.mountStyle, 5)
  }

  unMountStyle = () => {
    this.setState({style: {maxHeight: 0}})
  }

  mountStyle = () => {
    this.setState({style: {maxHeight: '300px'}})
  }

  componentDidMount(){
    setTimeout(this.mountStyle, 5)
  }

  transitionEnd = () => {
    if(!this.props.mounted){
      this.setState({show: false})
    }
  }

  render() {
    if (!this.state.show) {
      return null
    }
    return (
      <div className={css.text} style={this.state.style} onTransitionEnd={this.transitionEnd}>{this.props.text}</div>
    )
  }
}

export default MedicineGuideItemText



// WEBPACK FOOTER //
// ./src/homepage/components/MedicineGuideItemText.js